import { SmartEdge } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/SmartEdge/SmartEdge';
import { svgDrawSmoothLinePath } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/functions/drawSvgPath.ts';
import { pathfindingAStarDiagonal } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/functions/generatePath.ts';
import { BezierEdge, Edge, EdgeProps, Node, useNodes } from '@xyflow/react';
import { SmartEdgeOptions } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/SmartEdge/SmartEdge.types';

const StepConfiguration: SmartEdgeOptions = {
	drawEdge: svgDrawSmoothLinePath,
	generatePath: pathfindingAStarDiagonal,
	fallback: BezierEdge,
	gridRatio: 3,
	gridRatioDragging: 6,
	nodeXPadding: 20,
	nodeYPadding: 20,
	withConnectorPadding: false,
};

export function SmartBezierEdge<EdgeDataType extends Edge = Edge, NodeDataType extends Node = Node>(
	props: EdgeProps<EdgeDataType>
) {
	const nodes = useNodes<Node<NodeDataType>>();

	return (
		<SmartEdge<EdgeDataType, NodeDataType>
			{...props}
			options={StepConfiguration}
			nodes={nodes}
		/>
	);
}
